module.exports = __webpack_public_path__ + "img/54.2.TN.b5b76d03.png";